import api from '@/utils/axios';
import { unwrapList } from '@/utils/apiHelpers';
import type { ApiNamedResource } from './types';

export async function listUserSpecializations(userId: number): Promise<ApiNamedResource[]> {
  const res = await api.get(`/users/${userId}/specializations`);
  return unwrapList<ApiNamedResource>(res.data);
}

export async function syncUserSpecializations(userId: number, specializationIds: number[]): Promise<ApiNamedResource[]> {
  const res = await api.post(`/users/${userId}/specializations`, { specialization_ids: specializationIds });
  return unwrapList<ApiNamedResource>(res.data);
}

export async function detachUserSpecializations(userId: number, specializationIds: number[]): Promise<void> {
  await api.delete(`/users/${userId}/specializations`, { data: { specialization_ids: specializationIds } });
}

export async function listUserAvailabilitySlots(userId: number): Promise<ApiNamedResource[]> {
  const res = await api.get(`/users/${userId}/availability-slots`);
  return unwrapList<ApiNamedResource>(res.data);
}

export async function syncUserAvailabilitySlots(userId: number, slotIds: number[]): Promise<ApiNamedResource[]> {
  const res = await api.post(`/users/${userId}/availability-slots`, { availability_slot_ids: slotIds });
  return unwrapList<ApiNamedResource>(res.data);
}

export async function detachUserAvailabilitySlots(userId: number, slotIds: number[]): Promise<void> {
  await api.delete(`/users/${userId}/availability-slots`, { data: { availability_slot_ids: slotIds } });
}

export async function listUserCoverageZones(userId: number): Promise<ApiNamedResource[]> {
  const res = await api.get(`/users/${userId}/coverage-zones`);
  return unwrapList<ApiNamedResource>(res.data);
}

export async function syncUserCoverageZones(userId: number, zoneIds: number[]): Promise<ApiNamedResource[]> {
  const res = await api.post(`/users/${userId}/coverage-zones`, { zone_ids: zoneIds });
  return unwrapList<ApiNamedResource>(res.data);
}

export async function detachUserCoverageZones(userId: number, zoneIds: number[]): Promise<void> {
  await api.delete(`/users/${userId}/coverage-zones`, { data: { zone_ids: zoneIds } });
}
